import React, { useState, useEffect } from 'react';
import OwlCarousel from 'react-owl-carousel2';
import SectionTitle from '../Common/SectionTitle';
import SingleProject from './SingleProject';
import axios from 'axios';

const Project = () => {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch projects from the API
    useEffect(() => {
        axios.get('https://yautiktechnology.com/api/project')
            .then((response) => {
                setProjects(response.data);  // Assuming response.data contains the projects
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
                setLoading(false);
            });
    }, []);

    const options = {
        items: 3,
        nav: true,
        dots: false,
        margin: 30,
        rewind: false,
        autoplay: false,
        stagePadding: 30,
        loop: true,
        navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
        center: false,
        responsive: {
            0: {
                stagePadding: 0,
                items: 1,
                nav: false,
            },
            768: {
                items: 2,
                nav: false,
                stagePadding: 0,
            },
            992: {
                items: 2,
                nav: false,
                stagePadding: 0,
            },
            1200: {
                items: 3,
                nav: true,
                stagePadding: 0,
            },
            1500: {
                items: 3,
                stagePadding: 0,
            },
        }
    };

    return (
        <React.Fragment>
            <div id="rs-portfolio" className="rs-project style1 pt-110 md-pt-80 mb--150">
                <div className="container">
                    <SectionTitle
                        sectionClass="sec-title2 text-center mb-44 md-mb-30"
                        subtitleClass="sub-text white-color"
                        subtitle="Project"
                        titleClass="title white-color"
                        title="We Are Offering All Kinds of IT Solutions Services"
                    />
                    {loading ? (
                        <p>Loading projects...</p>  // Show loading message while fetching data
                    ) : (
                        <OwlCarousel options={options}>
                            {projects.map((project) => (
                                <SingleProject
                                    key={project.id}
                                    itemClass="project-item"
                                    projectImage={project.imageUrl}  // Using the imageUrl from the API
                                    Title={project.description}  // Using description from the API
                                    Category={project.projectSubTitle}  // Using projectSubTitle from the API
                                />
                            ))}
                        </OwlCarousel>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}

export default Project;
